/**
 * WGS84 - Earth's equatorial radius in meters
 */
export const EARTH_RADIUS_M = 6378137.0;
